import styled from 'styled-components';

export const StyledActions = styled.div`
  display: flex;
  height: 24px;
  align-items: center;
  overflow: visible; /* Allow tooltips to be visible */
  div.group {
    display: flex;
    height: 24px;
    border-radius: 12px;
    padding: 6px 4px 6px 6px;
    overflow: visible; /* Allow tooltips to be visible */
  }

  button {
    background: transparent;
    border: 0;
    cursor: pointer;
    border-radius: 4px;
    padding: 4px;
    transition: all 0.2s ease;

    svg path {
      fill: ${({ theme }) => theme.assessVisualizer.button.color};
      width: 14px;
      height: 14px;
    }

    &:hover {
      box-shadow: ${({ theme }) => theme.button.boxShadow};
      svg path {
        fill: ${({ theme }) => theme.assessVisualizer.button.color};
      }
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;

      &:hover {
        box-shadow: none;
      }
    }
  }
`;
